import {
  Slider as RACSlider,
  SliderFill as RACSliderFill,
  type SliderFillProps as RACSliderFillProps,
  SliderOutput as RACSliderOutput,
  type SliderOutputProps as RACSliderOutputProps,
  type SliderProps as RACSliderProps,
  SliderThumb as RACSliderThumb,
  type SliderThumbProps as RACSliderThumbProps,
  SliderTrack as RACSliderTrack,
  type SliderTrackProps as RACSliderTrackProps,
} from "react-aria-components";

export interface SliderProps<T extends number | number[] = number | number[]> extends RACSliderProps<T> {}
export interface SliderTrackProps extends RACSliderTrackProps {}
export interface SliderFillProps extends RACSliderFillProps {}
export interface SliderThumbProps extends RACSliderThumbProps {}
export interface SliderOutputProps extends RACSliderOutputProps {}

export function Slider<T extends number | number[] = number | number[]>(props: SliderProps<T>) {
  return <RACSlider {...props} />;
}

export function SliderTrack(props: SliderTrackProps) {
  return <RACSliderTrack {...props} />;
}

export function SliderFill(props: SliderFillProps) {
  return <RACSliderFill {...props} />;
}

export function SliderThumb(props: SliderThumbProps) {
  return <RACSliderThumb {...props} />;
}

export function SliderOutput(props: SliderOutputProps) {
  return <RACSliderOutput {...props} />;
}
